import React from 'react';

import { DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import Button from 'app/components/Button';
import { TextCell } from 'app/components/Table';
import moment from 'moment';
import { MenuItemType } from 'antd/lib/menu/hooks/useItems';

export const getAttachmentColDefs = (onDelete: any) => [
  {
    title: 'Attachment Name',
    dataIndex: 'fileName',
    key: 'fileName',
    render: (value: string, record: any) => {
      const { url } = record;
      const fileName = value.split(',')[1] || value;
      return (
        <Space align="center">
          <div style={{ width: 30, height: 30 }}>
            <a
              target={'_blank'}
              download={fileName}
              style={{ visibility: 'hidden' }}
              href={record.downloadUrl}
              id={record.id}
              rel="noreferrer"
            ></a>
            <img style={{ width: '100%' }} src={url}></img>
          </div>
          <Button
            type="link"
            onClick={() => {
              window.open(url, '_blank');
            }}
          >
            {fileName}
          </Button>
        </Space>
      );
    }
  },
  {
    title: 'Upload Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 250,
    render: (value: string) => {
      const date = moment(value);
      return (
        <TextCell>
          {date.isValid() ? date.format('DD/MM/YYYY') : 'N/A'}
        </TextCell>
      );
    }
  },
  {
    title: 'Download',
    dataIndex: 'download',
    key: 'templateNo',
    width: 90,
    render: (_: any, record: any) => {
      return (
        <Button
          type="text"
          onClick={() => {
            const linkNode: any = document.getElementById(record.id);
            linkNode && linkNode.click();
          }}
        >
          <DownloadOutlined></DownloadOutlined>
        </Button>
      );
    }
  },
  {
    title: 'Delete',
    dataIndex: 'download',
    key: 'templateNo',
    width: 90,
    render: (_: any, record: any) => {
      return (
        <Button
          type="text"
          danger
          onClick={() => {
            onDelete(record.id);
          }}
        >
          <DeleteOutlined></DeleteOutlined>
        </Button>
      );
    }
  }
];

type MenuItem = MenuItemType & {
  isApplicable?: (params: {
    assignOnsiteInspection: boolean;
    edit: boolean;
  }) => boolean;
};

export const JOB_DETAIL_MENU: MenuItem[] = [
  {
    label: 'Assign Onsite Inspection',
    key: 'assign-onsite-inspection',
    isApplicable: (params) => {
      return params.assignOnsiteInspection;
    }
  },
  {
    label: 'Edit Inspection Job',
    key: 'edit-inspection-detail',
    isApplicable: (params) => {
      return params.edit;
    }
  }, // remember to pass the key prop
  {
    label: 'Cancel Job',
    key: 'cancel-job'
  }
  // {
  //   label: 'Edit Inspection Criteria',
  //   key: 'edit-inspection-criteria'
  // }, // which is required
  // {
  //   label: 'Edit Inspector',
  //   key: 'edit-inspector'
  // },
  // {
  //   label: 'Cancel Inspection',
  //   key: 'cancel-inspection'
  // }
];
